const ProductivityMapsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 18.62C21 18.85 20.85 19.03 20.64 19.1L15 21L9 18.9L3.66 20.97L3.5 21C3.22 21 3 20.78 3 20.5V5.38C3 5.15 3.15 4.97 3.36 4.9L9 3L15 5.1L20.34 3.03L20.5 3C20.78 3 21 3.22 21 3.5V18.62ZM19 17.542L15.0124 18.8854L8.96469 16.7687L5 18.3056V6.45796L8.98759 5.11462L15.0353 7.23132L19 5.69445V17.542Z"
        fill={props?.fill ?? "#696F88"}
      />
      <path
        d="M8.00217 8.51169C8.00425 8.55713 8.00831 8.62119 8.01628 8.69985C8.03216 8.85668 8.06382 9.0742 8.12732 9.31954C8.25184 9.80061 8.5107 10.4356 9.06631 10.9123C9.62991 11.3958 10.3238 11.5682 10.849 11.6244C10.9967 11.6402 11.134 11.6471 11.2553 11.649V16H12.1854V14.2629C12.2912 14.2679 12.4087 14.2712 12.5343 14.2712C13.0232 14.2711 13.6917 14.2205 14.254 13.9786C14.8436 13.725 15.2492 13.242 15.4956 12.8724C15.6232 12.6809 15.7185 12.504 15.782 12.3748C15.8139 12.3099 15.8381 12.2564 15.8547 12.2182C15.8547 12.2182 15.9021 12.1293 16 11.8493C15.8546 11.7509 15.603 11.6481 15.603 11.6481C15.5598 11.6289 15.4993 11.6035 15.424 11.5758C15.2741 11.5207 15.0614 11.455 14.8052 11.411C14.292 11.323 13.5844 11.32 12.8762 11.6846C12.6031 11.8252 12.3751 11.9927 12.1854 12.1697L12.1858 11.2258C12.1863 11.2131 12.1869 11.1955 12.1873 11.1733C12.188 11.1289 12.1881 11.0661 12.1856 10.9888C12.1806 10.8346 12.1652 10.6202 12.1234 10.377C12.0416 9.90145 11.8507 9.26585 11.3858 8.76768C10.8755 8.22095 10.0738 8.06015 9.49347 8.01576C9.19186 7.99268 8.91974 7.99867 8.72359 8.01017C8.625 8.01595 8.54425 8.0232 8.48696 8.02918C8.48696 8.02918 8.45418 8.02918 8 8.09561C8.00004 8.41832 8.00217 8.51169 8.00217 8.51169Z"
        fill={props?.fill ?? "#696F88"}
      />
    </svg>
  );
};

export default ProductivityMapsIcon;
